import React, { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import moment from "moment";
import { AiOutlineLogout, } from "react-icons/ai";
import { connect } from "react-redux";

import { userSignOut, verifyOtp } from "../appRedux/actions/Auth";
import { send2faOtpAPI } from "../services/users-service";
import { history } from "../appRedux/store";

const FormItem = Form.Item;

const totalSeconds = 60;
const VerifyAccountForm = (props) => {
    const { submitting, authUser, form } = props;
    const { getFieldDecorator } = form;

    const [disabled, setDisabled] = useState(true);
    const [seconds, setSeconds] = useState(totalSeconds);

    useEffect(() => {
        if (!authUser) {
            history.push('/signin');
        }
        if (authUser && authUser.authenticated) {
            history.push('/');
        }
    }, [authUser])

    useEffect(() => {
        if (authUser && authUser.twoFactorAuthType === "EMAIL" && !authUser.authenticated) {
            const counter = setInterval(() => {
                if (seconds > 0) {
                    setSeconds(seconds - 1)
                } else {
                    clearInterval(counter);
                    setDisabled(false);
                }
            }, 1000);
            return () => {
                clearInterval(counter);
            }
        }
    }, [authUser, seconds]);

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                const data = {
                    email: authUser.email,
                    code: values.code
                }
                props.verifyOtp(data)
            } else {
                message.error("Please enter OTP!");
            }
        });
    };

    const resendOtp = async () => {
        const response = await send2faOtpAPI(authUser.userId, authUser.email);
        if (response.success) {
            setSeconds(totalSeconds);
            setDisabled(true);
            message.success("OTP sent successfully!");
        } else {
            message.error("Failed to send OTP.");
        }
    }

    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-logo">
          <img alt="example" src={require("assets/images/clarity-logo.png")} />
        </div>
        <div className="gx-app-login-container">
            <div className="gx-app-login-main-content">
                <div className="gx-app-login-content">
                  <h1>Verify Account</h1>
                  {
                      authUser &&
                      <p>Hi {`${authUser.firstName} ${authUser.lastName}`}!</p>
                  }
                  {
                      authUser && authUser.twoFactorAuthType === "EMAIL" ?
                          <p>{`Please enter OTP sent to ${authUser.email}`}</p> :
                          <p>Please enter OTP generated on your authenticator app.</p>
                  }
                  <Form onSubmit={handleSubmit} style={{ margin: "0 15px" }}>
                      <FormItem>
                          {getFieldDecorator('code', {
                              initialValue: "",
                              rules: [
                                  { required: true, message: 'Please input OTP!' },
                                  { len: 6, message: 'Please enter 6 digit code!' }
                              ],
                          })(
                              <Input type="number" className="otp-input" placeholder="Enter OTP" maxLength={6} />
                          )}
                      </FormItem>
                      <FormItem>
                          <Button type="primary" loading={submitting} htmlType="submit">
                              Verify
                          </Button>
                          {
                              authUser && authUser.twoFactorAuthType === "EMAIL" &&
                              <Button style={{ float: "right" }} type="primary" loading={submitting} disabled={disabled} onClick={resendOtp}>
                                  Resend OTP
                              </Button>
                          }
                      </FormItem>
                      <div style={{ float: "right" }}>
                          {
                              authUser && authUser.twoFactorAuthType === "EMAIL" &&
                              <p><span style={{ color: "grey" }}>Resent OTP in </span>&nbsp;
                                  <span style={{ color: "green" }}>{moment.utc(seconds * 1000).format('mm:ss')}</span>
                              </p>
                          }
                      </div>
                  </Form>
              </div>
            </div>
        </div >
        <div style={{ position: "absolute", top: '1rem', right: '2rem' }}>
            <Button
                type="default"
                size='large'
                onClick={() => props.userSignOut()}
                shape="circle"
                id="signout-btn"
                style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
                <AiOutlineLogout size="1.3em" />
            </Button>
        </div>
      </div>
    );
};

const VerifyAccount = Form.create()(VerifyAccountForm);

const mapStateToProps = ({ auth }) => {
    const { submitting, authUser } = auth;
    return { submitting, authUser }
};

export default connect(mapStateToProps, { userSignOut, verifyOtp })(VerifyAccount);
